import { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home.js';
import Residential from './pages/CustomerResidential.js';
import Commercial from './pages/CustomerCommercial.js';
import Contractors from './pages/CustomerContractors.js';
import ContactPagePartner from './pages/ContactPagePartner.js';
import ContactPagePartnerThankYou from './pages/ContactPagePartnerThankYou.js';
import ContactPageInfo from './pages/ContactPageInfo.js';
import ContactPageInfoThankYou from './pages/ContactPageInfoThankYou.js';
import ContactPageFree from './pages/ContactPageFree.js';
import ContactPageFreeThankYou from './pages/ContactPageFreeThankYou.js';
import About from './pages/About.js';
import TermsOfUse from './pages/TermsOfUse.js';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import Carriers from './pages/Carriers.js';
import NotFound from './pages/NotFound.js';
import ScrollToTop from './components/ScrollToTop.js';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      setIsVisible(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <img
      className={`scroll-to-top-button ${isVisible ? 'show' : ''}`}
      src={process.env.PUBLIC_URL + "/images/svg-icons/up-arrow.svg"}
      alt="Scroll to Top"
      onClick={scrollToTop}
    />
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/residential" element={<Residential />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/contractors" element={<Contractors />} />
          <Route path="/about" element={<About />} />
          <Route path="/PARTNER" element={<ContactPagePartner />} />
          <Route path="/PARTNER_TY" element={<ContactPagePartnerThankYou />} />
          <Route path="/INFO" element={<ContactPageInfo />} />
          <Route path="/INFO_TY" element={<ContactPageInfoThankYou />} />
          <Route path="/FREE" element={<ContactPageFree />} />
          <Route path="/FREE_TY" element={<ContactPageFreeThankYou />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/carriers" element={<Carriers />} />
          <Route path="*" element={<NotFound />} /> 
        </Routes>
        <ScrollToTopButton />
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default App;
